module.exports = __webpack_public_path__ + "static/media/warning.c4c9f03d.svg";